<template>
  <section class="login">
    <transition name="fade" mode="out-in">
      <div class="modal-overlay" v-if="$root.loginFormShow"></div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="modal" v-if="$root.loginFormShow">
        <span
          class="button"
          @click="
            $root.loginFormShow = false;
            close_nav();
          "
        >
          <i class="share-close">&times;</i>
        </span>
        <ValidationObserver ref="observer">
          <b-form
            slot-scope="{ validate }"
            @submit.prevent="validate().then(handleSubmit)"
          >
            <div class="row">
              <div class="col-6 login_image">
                <img src="../assets/img/login.png" />
              </div>
              <div class="col-5 one_row">
                <h2 v-if="$root.loginFormShow">Login</h2>
                <div class="login_wrap">
                  <ValidationProvider rules="required|alpha_spaces" name="email">
                    <b-form-group slot-scope="{ valid, errors }">
                      <b-form-input
                        type="text"
                        :state="errors[0] ? false : valid ? true : null"
                        placeholder="Email"
                      ></b-form-input>
                      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </div>
                <div class="login_wrap">
                  <ValidationProvider rules="required|alpha_spaces" name="password">
                    <b-form-group slot-scope="{ valid, errors }">
                      <b-form-input
                        type="password"
                        :state="errors[0] ? false : valid ? true : null"
                        placeholder="Password"
                      ></b-form-input>
                      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                  <div>
                    <a @click="Hasforget" class="pull-right need-help">
                      Forgot your Password?
                    </a>
                  </div>
                </div>
                <div class="">
                  <div class="button_body">
                    <button class="button_body_1" block type="submit" variant="primary">
                      Login
                    </button>
                  </div>
                </div>
                <div
                  class="create_body"
                  @click="
                    $root.loginFormShow = false;
                    close_nav();
                  "
                >
                  <p>
                    Don't have an volunteer account?
                    <router-link to="/registration"> Apply Now </router-link>
                  </p>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </transition>

    <section class="login forget">
      <transition name="fade" mode="out-in">
        <div class="modal-overlay" v-if="forgetFormShow"></div>
      </transition>
      <transition name="fade" mode="out-in">
        <div class="modal" v-if="forgetFormShow">
          <span
            class="button"
            @click="
              forgetFormShow = false;
              $root.loginFormShow = false;
              close_nav();
            "
          >
            <i class="share-close">&times;</i>
          </span>
          <ValidationObserver ref="observer">
            <b-form
              slot-scope="{ validate }"
              @submit.prevent="validate().then(handleSubmit)"
            >
              <div class="row">
                <div class="col login_image">
                  <img src="../assets/img/login.png" />
                </div>
                <div class="col one_row">
                  <h2>Did you forgot your passwprd</h2>
                  <p>
                    Enter your email address you're using for you account below and we
                    will send you a password reset link.
                  </p>
                  <div class="login_wrap">
                    <ValidationProvider rules="required|alpha_spaces" name="email">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Email Address"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="">
                    <div class="button_body">
                      <button class="button_body_1" block type="submit" variant="primary">
                        Reqest Reset link
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </b-form>
          </ValidationObserver>
        </div>
      </transition>
    </section>
  </section>
</template>
<script>
export default {
  data() {
    return {
      forgetFormShow: false,
    };
  },
  methods: {
    Hasforget() {
      this.forgetFormShow = !this.forgetFormShow;
    },

    close_nav() {
      var navToggler = document.getElementById("navbarTogglerButton");
      navToggler.click();
    },
  },
};
</script>

<style scoped>
.login_image img {
  width: 90%;
  display: flex;
}
.forget .modal {
  z-index: 1031;
}
.forget .modal-overlay {
  z-index: 1031;
}
.login .form-control {
  font-size: 24px !important;
  font-weight: 600;
  opacity: 1;
  border: 1px solid #fff0;
  margin-left: auto;
  height: 29px;
  margin-top: auto;
  width: 100%;
  max-width: 100%;
  background-color: rgb(0 0 0 / 0%);
  border-bottom: 2px solid #9c9c9c;
  padding: 5px;
  padding-bottom: 12px;
}
.login form {
  display: flex;
  justify-content: center;
  /* display: flex; */
  align-items: center;
  height: 100%;
}
.login .modal {
  height: 100vh;
}
.login .modal span {
  display: inline;
}
.login .modal .one_row h2 {
  padding: 20px 0px 40px 0px;
}
.login .modal .one_row .login_wrap {
  padding: 0px 0px 35px 0px;
  margin-bottom: 15px;
}
.login .modal .one_row .button_body {
  padding: 10px;
  background: #07cddb;
  border-radius: 50px;
}
.forget .modal .one_row .button_body,
.forget .modal .one_row .login_wrap {
  width: 60%;
}
.forget .row {
  align-items: center;
  width: 90%;
}
.forget .login_image img {
  width: 80%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: auto;
  margin-right: auto;
}
.login .modal .one_row .button_body button {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: block;
  font-size: 20px;
}
.login .modal .one_row .login_wrap .form-group {
  display: block;
}
.login .modal .create_body {
  text-align: center;
  padding-top: 20px;
}

.login .modal .create_body a {
  color: #07cddb;
  cursor: pointer;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(100em);
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
</style>
